import { useCallback, useEffect, useRef, useState } from "react";
import QRScan from "../../components/qr_scan";
import { Controller, useForm } from "react-hook-form";
import CONFIG from "../../constanta/config";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import useUser from "../../hook/useUser";
import ReactSelect from "react-select";
import moment from "moment";
import { useQuery } from "../../hook/useQuery";

import Webcam from "react-webcam";

const FormRFIDResult = (props) => {
  const webcamRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const query = useQuery();
  const [checkAllow, setCheckAllow] = useState("");
  const [showGuest, setShowGuest] = useState(false);
  const [listGuest, setListGuest] = useState([]);
  const [gate, setGate] = useState(null);

  useEffect(() => {
    if (props.user.event_gate) {
      let _gate = props.user.event_gate?.find(
        (v) => v.id_gate === query.get("id_gate")
      );
      setGate(_gate);
    }
  }, [props?.user]);

  useEffect(() => {
    initAllowed();
  }, [gate]);

  useEffect(() => {
    if (checkAllow !== "") {
      if (
        checkAllow === "already-checkout" ||
        checkAllow === "havent-checkin"
      ) {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
        return;
      }
    }
  }, [checkAllow]);

  const togleGuest = (idx) => {
    let arr = [...listGuest];
    arr[idx].active = !arr[idx].active;
    setListGuest(arr);
  };

  const onSubmit = () => {
    if (loading) return;

    setLoading(true);

    handleCheckout();
  };

  const videoConstraints = {
    width: { min: 720 },
    height: { min: 480 },
    facingMode: "user",
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const capture = useCallback(() => {
    setImageSrc(webcamRef.current.getScreenshot());
  }, [webcamRef]);

  const retake = () => {
    setImageSrc(null);
  };

  const canSubmit = () => {
    if (imageSrc === null) {
      return false;
    } else {
      return true;
    }
  };

  const handleCheckout = () => {
    if (imageSrc === null) {
      return;
    }

    var file = dataURLtoFile(imageSrc, "photo.png");

    const payload = {
      id_user: props?.user?.id_user,
      id_gate: query.get("id_gate"),
      photo: file,
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    try {
      axios
        .post(CONFIG.URL + "/event/checkout", form_data, {
          headers: {
            token: Cookies.get("token"),
          },
        })

        .then(function (response) {
          setLoading(false);
          if (response?.data.status === "SUCCESS") {
            props.onSuccess();
          } else {
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const handleReentry = () => {
    const payload = {
      id_gate: query.get("id_gate"),
      rfid: props?.user?.rfid,
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    try {
      axios
        .post(CONFIG.URL + "/event/rfidx/reentry", form_data, {
          headers: {
            token: Cookies.get("token"),
          },
        })

        .then(function (response) {
          setLoading(false);
          if (response?.data.status === "SUCCESS") {
            props.onSuccess();
          } else {
          }
        })
        .catch(function (error) {
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
    }
  };

  const initAllowed = () => {
    // if (props.user.exit_time !== undefined) {
    //   setCheckAllow("allowed-to-re-checkin-new");
    // } else {
    // }

    if (gate !== null) {
      if (gate.checkout_time === "0000-00-00 00:00:00") {
        if (gate.checkin_time !== "0000-00-00 00:00:00") {
          setCheckAllow("allowed-to-checkout");
        } else {
          setCheckAllow("havent-checkin");
        }
      } else {
        if (
          moment(gate.checkin_time) < moment(gate.checkout_time) &&
          gate.reentry_time === "0000-00-00 00:00:00"
        ) {
          setCheckAllow("already-checkout");
        } else if (moment(gate.reentry_time) < moment(gate.checkout_time)) {
          setCheckAllow("already-checkout");
        } else {
          setCheckAllow("allowed-to-checkout");
        }
      }
    } else {
      setCheckAllow("wrong-gate");
    }
  };

  const getCheckinTime = () => {
    if (Date.parse(gate?.reentry_time) > Date.parse(gate?.checkin_time)) {
      return gate?.reentry_time;
    } else {
      return gate?.checkin_time;
    }
  };

  const handleShowGuest = () => {
    if (showGuest) {
      setListGuest([]);
      setShowGuest(false);
    } else {
      setListGuest([
        {
          label: "Guest 1",
          active: true,
        },
        {
          label: "Guest 2",
          active: false,
        },
        {
          label: "Guest 3",
          active: false,
        },
      ]);
      setShowGuest(true);
    }
  };

  return (
    <>
      <div className="space-y-3 px-5 py-3 bg-white rounded-md items-center justify-center flex flex-col w-full md:w-1/2 transition-all">
        <div className="text-center font-bold">
          <div>CHECKOUT</div>
          <div className="text-xl uppercase">REST {query.get("gate")}</div>
        </div>

        {checkAllow === "allowed-to-checkout" && (
          <div className="uppercase bg-green-500 w-full text-center py-2 text-white font-bold rounded">
            ALLOWED TO Checkout
          </div>
        )}

        {checkAllow === "already-checkout" && (
          <div className="bg-red-500 w-full text-center py-2 text-white font-bold rounded">
            ALREADY CHECKOUT
          </div>
        )}

        {checkAllow === "havent-checkin" && (
          <div className="bg-red-500 w-full text-center py-2 text-white font-bold rounded">
            Haven't Checked in
          </div>
        )}

        {checkAllow === "wrong-gate" && (
          <div className="bg-red-500 w-full text-center py-2 text-white font-bold rounded">
            WRONG GATE
          </div>
        )}

        {/* <div className="bg-red-500 w-full text-center py-5 text-white font-bold rounded">
          ALREADY CHECKED IN
        </div> */}

        <div
          className={`cursor-pointer text-white flex flex-col justify-center items-center  text-black font-bold px-5 py-1 rounded`}
        >
          {props.user !== null ? (
            <>
              <div className="text-center text-xl font-bold text-black uppercase mb-1">
                {props.user.username}
              </div>

              {!props?.user?.notfound && (
                <div className="text-center text-xl font-bold text-black uppercase mb-1">
                  <div className="text-black font-normal capitalize">
                    Section:
                  </div>
                  <div>{props.user.section}</div>
                </div>
              )}

              {checkAllow === "allowed-to-checkout" && (
                <>
                  <div className="relative shadow-lg drop-shadow-lg overflow-hidden max-w-[320px] mt-5">
                    <div
                      className={`${
                        imageSrc !== null ? "invisible" : "visible"
                      }`}
                    >
                      <Webcam
                        audio={false}
                        height={600}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        width={800}
                        videoConstraints={videoConstraints}
                        screenshotQuality={1}
                        imageSmoothing={true}
                        mirrored
                      />
                    </div>

                    {imageSrc !== null && (
                      <img
                        alt=""
                        src={imageSrc}
                        className={`${
                          imageSrc !== null ? "block" : "hidden"
                        } w-full h-full object-contain absolute top-0 left-0`}
                      />
                    )}
                  </div>

                  <div className="flex justify-center items-center my-2">
                    {imageSrc === null ? (
                      <button
                        onClick={() => capture()}
                        type="button"
                        className={`cursor-pointer w-max px-4 py-1 rounded-lg text-white font-bold bg-blue-500  text-center`}
                      >
                        Capture
                      </button>
                    ) : (
                      <button
                        onClick={() => retake()}
                        type="button"
                        className={`cursor-pointer w-max px-4 py-1 rounded-lg text-white font-bold bg-orange-500  text-center`}
                      >
                        Retake
                      </button>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              {" "}
              <div className="text-center  font-bold text-black text-4xl mt-4">
                NOT FOUND
              </div>
            </>
          )}
        </div>

        <>
          <div className="mx-auto flex justify-center items-center space-x-4">
            {checkAllow === "allowed-to-checkout" && (
              <button
                type="button"
                onClick={() => props.ok()}
                className={`px-10 py-2 rounded-lg text-white font-bold bg-red-500  w-full text-center`}
              >
                CANCEL
              </button>
            )}

            {checkAllow === "allowed-to-checkout" && (
              <div className="flex space-x-5">
                {canSubmit() ? (
                  <button
                    type="button"
                    onClick={() => onSubmit()}
                    className={` min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-green-500  w-full text-center`}
                  >
                    {loading ? "Loading..." : "Confirm"}
                  </button>
                ) : (
                  <button
                    className={`cursor-not-allowed min-w-[160px] px-10 py-2 rounded-lg text-white font-bold bg-gray-500  w-full text-center`}
                  >
                    Confirm
                  </button>
                )}
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};

export default FormRFIDResult;
